<script>
    import RayBan from 'desktop/icons/brands/RayBan.svelte';
    import Oakley from 'desktop/icons/brands/Oakley.svelte';
    import Burberry from 'desktop/icons/brands/Burberry.svelte';
    import ArmaniExchange from 'desktop/icons/brands/ArmaniExchange.svelte';
    import MichaelKors from 'desktop/icons/brands/MichaelKors.svelte';

    import s from './style.module.css';
</script>

<div class={s.brandsContainer}>
    <RayBan />
    <Oakley />
    <Burberry />
    <ArmaniExchange />
    <MichaelKors />
    <span class={s.text}>And More</span>
</div>
